export default {
  faqs: [],
};
